import React, { useState, useEffect } from "react";
import Select from "react-select";
import { FormFeedback, Tooltip } from "reactstrap";

const DropdownInput = ({
    label = "Select Option",
    required = false,
    layout = "below",
    options = [],
    defaultSelectedKey = "",
    name = "dropdown",
    id = "dropdownInput",
    onChange = () => { },
    onBlur = () => { },
    requiredErrorMessage = "You must select at least one option.",
    placeholder = "Please select an option",
    showHelp = false,
    helpText = "Please select an option.",
    isClearable = true,
    validateTrigger = false,
    disabled = false,
    value
}) => {
    const [selectedValue, setSelectedValue] = useState(null);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        if (value) {
            setSelectedValue(value);
        } else {
            const defaultSelectedOption = options.find(option => option.value === defaultSelectedKey);
            setSelectedValue(defaultSelectedOption || null);
        }
    }, [value, defaultSelectedKey, options]);

    const validateInput = (value) => {
        const newErrors = {};
        if (required && !value) {
            newErrors.required = requiredErrorMessage;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        if (validateTrigger) {
            validateInput(selectedValue);
        }
    }, [validateTrigger, selectedValue]);

    const handleOptionSelect = (selectedOption) => {
        setSelectedValue(selectedOption);
        validateInput(selectedOption);
        onChange(selectedOption);
    };

    return (
        <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>

            <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "25%" : "100%" }}>
                <span>
                    {label}
                    {required && <span className="text-danger ml-1">*</span>}
                    {showHelp && (
                        <span id={`helpTooltip-${id}`} className="ms-1"
                            style={{ position: "relative", top: "-3px" }}
                        >
                            <i className="ri-question-line" style={{ cursor: 'pointer', fontSize: '16px' }}></i>
                        </span>
                    )}
                </span>
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={`helpTooltip-${id}`}
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}

            <div className="w-100">
                <Select
                    name={name}
                    id={id}
                    value={selectedValue}
                    onChange={handleOptionSelect}
                    onBlur={() => validateInput(selectedValue)}
                    options={options}
                    placeholder={placeholder}
                    isSearchable
                    isClearable={isClearable}
                    classNamePrefix="react-select"
                    className={errors.required ? 'is-invalid' : ''}
                    isDisabled={disabled}
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            minHeight: '38px',
                            fontSize: '14px',
                            marginTop: '2px'
                        }),
                        placeholder: (provided) => ({
                            ...provided,
                            fontSize: '14px'
                        }),
                        input: (provided) => ({
                            ...provided,
                            fontSize: '14px'
                        })
                    }}
                />
                {errors.required && (
                    <FormFeedback type="invalid" style={{ display: 'block' }}>
                        {errors.required}
                    </FormFeedback>
                )}
            </div>
        </div>
    );
};

export default DropdownInput;
